import { render, staticRenderFns } from "./ai_multiterm.vue?vue&type=template&id=1b87a536&scoped=true"
import script from "./ai_multiterm.vue?vue&type=script&lang=js"
export * from "./ai_multiterm.vue?vue&type=script&lang=js"
import style0 from "./ai_multiterm.vue?vue&type=style&index=0&id=1b87a536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87a536",
  null
  
)

export default component.exports